import { alpha } from "@mui/material/styles";
import type { SxProps, Theme } from "@mui/material/styles";

export const MANAGEMENT_AVATAR_SIZE = 40;
export const MANAGEMENT_AVATAR_FONT_SIZE = "0.875rem";

export const MANAGEMENT_ADD_MORE_BUTTON_SX: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.cards.orangeBg,
  color: (theme) => theme.palette.warning.main,
  borderRadius: (theme) => `${theme.shape.borderRadius}px`,
  textTransform: "none",
  fontSize: (theme) => theme.typography.body2.fontSize,
  fontWeight: 500,
  px: 2,
  py: 0.75,
  boxShadow: "none",
  "&:hover": {
    backgroundColor: (theme) => theme.palette.cards.orangeHover,
    boxShadow: "none",
  },
};

/** Inline text action for management list rows (matches family section links). */
export const MANAGEMENT_TEXT_LINK_SX: SxProps<Theme> = {
  p: 0,
  minWidth: 0,
  typography: "body2",
  fontWeight: 500,
  textTransform: "none",
  color: "primary.main",
  "&:hover": {
    bgcolor: "transparent",
    textDecoration: "underline",
  },
};

export const MANAGEMENT_MOBILE_FAB_SX: SxProps<Theme> = {
  position: "fixed",
  right: 20,
  bottom: "calc(env(safe-area-inset-bottom, 0px) + 84px)",
  width: 58,
  height: 58,
  boxShadow: (theme) => `0 6px 18px ${alpha(theme.palette.primary.main, 0.35)}`,
  zIndex: (theme) => theme.zIndex.speedDial,
};

/** Bottom padding on phones so a page's last button can scroll clear of the FAB above. */
export const MOBILE_FAB_CLEARANCE = "calc(env(safe-area-inset-bottom, 0px) + 136px)";

/** Fade / disable pointer events while scrolling (see `useMobileFabVisibility`). */
function mobileFabScrollVisibilityObject(visible: boolean) {
  return {
    opacity: visible ? 1 : 0,
    pointerEvents: visible ? ("auto" as const) : ("none" as const),
    transition: (theme: Theme) =>
      theme.transitions.create(["opacity"], { duration: 200 }),
  };
}

/** Typed for MUI `Fab` / `Box` `sx` (avoids loose `SxProps` array inference issues). */
export function mobileFabWithScrollVisibility(
  base: SxProps<Theme>,
  scrollVisible: boolean,
): SxProps<Theme> {
  return [base, mobileFabScrollVisibilityObject(scrollVisible)] as SxProps<Theme>;
}
